import { useContext } from "react";
import { FormContext } from "./formContext";

const createContextStateSelector = (context) => (selector) => {
  return selector(useContext(context));
}

export const useFormContextStateSelector = createContextStateSelector(FormContext)